import { Typography } from "@mui/material"
import CustomConfirmDialog from "../../../core/components/common/custom-confirm-dialog.component"
import CustomLoader from "../../../core/components/common/custom-loader.component"
import { useGates } from "../hooks/useGates"
import GateService from "../services/api"
import { useEffect } from "react"

const UpdateGateStatusDialog = ({open, close, currentSelectedGate}) => {

    const {isLoadingGetGates, updatedGateStatus, errorUpdateGateStatus, updateGateStatus} = useGates()
    const status = currentSelectedGate?.status;

    useEffect(() => {
        if (updatedGateStatus) close()
    }, [JSON.stringify(updatedGateStatus)])

    const handleConfirm = () => {
        let gate_uid = currentSelectedGate.gate_uid
        let status = currentSelectedGate.status.toLowerCase() == 'active' ? 'Deactivated' : "Active" 
        updateGateStatus(gate_uid, status)
    }

    return(
        <>
            <CustomConfirmDialog
            loading={isLoadingGetGates}
            open={open}
            handleClose={close}
            handleConfirm={handleConfirm} 
            title={`${status.toLowerCase() == 'active' ? "Deactivate" : "Activate"} Gate`}
            >
            <div>
                {isLoadingGetGates ? (
                    <CustomLoader />
                ):(
                    <Typography>{`Are you sure you want to ${status.toLowerCase() == 'active' ? "deactivate" : "activate"} this gate?`}</Typography>
                )}
            </div>
        
            </CustomConfirmDialog>
        </>
    )
}

export default UpdateGateStatusDialog